import {
  arrayOf,
  bool,
  string,
  fragment,
  namedFragment,
  shape,
  customType,
  params,
  typename
} from '@thd-nucleus/data-sources';

const EmtDescription = {};
EmtDescription.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['Description_New']).isRequired(),
  }).shape({
    Description_New: fragment().shape({
      id: string(),
      title: string(),
      descriptionText: string()
    }),
  }),
};

const baseLayoutFragment = {
  id: string(),
  title: string(),
  seoLinks: shape({
    id: string()
  })
};

const DamMediaFragment = namedFragment({
  inline: false,
  fragmentType: 'DamMedia',
  fragmentAlias: 'DamMediaV2'
}).shape({
  damContentSelector: shape({
    assetData: arrayOf(
      shape({
        selectedImageUrl: string()
      })
    )
  }),
  damDownloadedContent: shape({
    url: string()
  }),
  imageHotspot: shape({
    id: string(),
    componentName: string(),
    imageUrl: string()
  }),
  __typename: typename('DamMedia')
});

const HeroFlattenImage = {
  id: string(),
  mobilePreviewImage: DamMediaFragment,
  previewImage: DamMediaFragment,
  title: string(),
  link: string(),
  componentName: string(),
  proAnalyticsCampaign: string(),
  proAnalyticsComponent: string(),
  __typename: typename('HeroFlattenImage'),
};

const HeroFlattenImageFragment = namedFragment({
  inline: true,
  fragmentType: 'HeroFlattenImage',
  fragmentAlias: 'HeroFlattenImage'
}).shape({
  ...HeroFlattenImage
});

const dynamicSectionsFragment = {
  __typename: string(),
  id: string(),
  title: string(),
  theme: string(),
  isCarousel: bool(),
  itemTheme: string(),
  components: arrayOf(shape({
    HeroFlattenImage: HeroFlattenImageFragment
  })),
};

export const universalLayoutFragment = fragment().shape({
  ...baseLayoutFragment,
  // TODO: see about getting nullability shapes
  // consistent with base 3

  flexibleCluster1: arrayOf(dynamicSectionsFragment),
  richText: arrayOf(shape({
    title: string(),
    descriptionText: string(),
    description: string()
  }))
});
